import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import React, { MouseEventHandler } from 'react';

import { IconButtonWithColors } from '@/components/IconButtonWithColors.comp.tsx';
import { themeColors } from '@/config/theme/themeColors.ts';

interface Props {
  isDeleting?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  sx?: SxProps;
}

export const DeleteIconButton: React.FC<Props> = props => {
  const { isDeleting, onClick, sx } = props;

  const handleClick: MouseEventHandler<HTMLButtonElement> = event => {
    event.stopPropagation();
    onClick?.(event);
  };

  if (isDeleting) {
    return (
      <Box sx={{ color: themeColors.red, height: '36px', p: 1, width: '36px' }}>
        <CircularProgress
          size={24}
          sx={{ color: themeColors.red, height: '100%', width: '100%' }}
        />
      </Box>
    );
  }

  return (
    <Box>
      <IconButtonWithColors
        color={themeColors.red}
        hoverColor={themeColors.redDark}
        icon={<DeleteOutlineOutlinedIcon />}
        onClick={handleClick}
        sx={sx}
      />
    </Box>
  );
};
